// Overlay "処理中..." dùng chung — hiện khi nút gửi request đang xử lý (vài giây),
// để user biết hệ thống đang làm việc (submit/表示/reorder/領収証/printer...).
// API: window.inkProcessing.show(msg?) / .hide(). Đếm ref → nhiều call lồng nhau
// vẫn ẩn đúng lúc. Inline styles (KHÔNG Tailwind class — tránh JIT purge khi inject
// động). Khác skeleton loading (skeleton = hydrate nội dung; overlay = action chờ).
(function () {
  'use strict';

  let el = null;
  let count = 0;

  function ensure() {
    if (el) return el;
    const style = document.createElement('style');
    style.textContent = '@keyframes ink-proc-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);

    el = document.createElement('div');
    el.setAttribute('role', 'alert');
    el.setAttribute('aria-busy', 'true');
    el.setAttribute('aria-live', 'assertive');
    el.style.cssText = 'position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.45)';
    el.innerHTML =
      '<div style="background:#fff;border-radius:10px;padding:24px 34px;display:flex;flex-direction:column;align-items:center;gap:14px;box-shadow:0 8px 30px rgba(0,0,0,.25)">'
      + '<span style="width:38px;height:38px;border:4px solid #e5e5e5;border-top-color:#01b245;border-radius:50%;animation:ink-proc-spin .8s linear infinite"></span>'
      + '<span data-ink-proc-text style="font-size:15px;font-weight:700;color:#333">処理中...</span>'
      + '</div>';
    document.body.appendChild(el);
    return el;
  }

  window.inkProcessing = {
    show: function (msg) {
      const n = ensure();
      n.querySelector('[data-ink-proc-text]').textContent = msg || '処理中...';
      count++;
      n.style.display = 'flex';
    },
    hide: function () {
      count = Math.max(0, count - 1);
      if (count === 0 && el) el.style.display = 'none';
    },
  };
})();
